<template>
  <section class="page-section bg-light" id="portfolio">

    <div v-if="$apollo.loading" class="text-center">
        <strong>loading ...</strong>
    </div>
    <div class="container" v-if="show">
      <div class="text-center">
        <h2 class="section-heading text-uppercase" id="pageTitle">{{ show.title }}</h2>
        <h3
          class="section-subheading text-muted"
        >{{ printTime(show.date_on_air) }} by {{ show.djs }}</h3>
      </div>


    <iframe width="100%" height="60" :src="mixcloud_widget_url()" frameborder="0" ></iframe>
      <!-- <div class="text-center mb-4">
        <a href title="Click to start listening" class="mr-4 playme" @click.prevent="playThisShow(show)">
          <i class="fas fa-headphones fa-4x"></i><br /> Click here to listen to this broadcast
        </a>
      </div> -->

      <div class="card-columns" v-show="show.tracks">

        <transition-group appear name="fade" tag="div">
          <div
            v-show="track"
            v-for="(track, index) in show.tracks"
            :key="index"
            :track="track"
            class="card"
          >
            <img
              :title="track.artist"
              class="card-img-top img-fluid"
              v-if="track.image"
              :src="track.image"
              @error="errorOnImageLoad"
              :alt="printArtistAndTitle(track)"
            />
            <img v-if="!track.image" class="img-fluid" src="../assets/placeholder.png" />
            <div class="card-body">
              <h5 class="card-title">
                <span class="badge badge-primary badge-pill">{{index+1}}</span>
                {{track.artist}}
              </h5>
              <h6 class="card-subtitle mb-2 text-muted">{{track.track}}</h6>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </section>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "showDetail",
  data: function () {
    return {
      show: null,
      params: this.$route.params,
    };
  },
  computed: {},
  methods: {
    errorOnImageLoad: function (el) {
      el.target.src = "img/placeholder.8319c67d.png";
    },
    printTime: function (timeOfBroadcast) {
      return moment(timeOfBroadcast).format("MMMM Do YYYY");
    },
    printArtistAndTitle: function (track) {
      if (track) {
        return track.artist + " // " + track.track;
      } else {
        return "";
      }
    },
    mixcloud_widget_url(){
        if ( this.show ){
            let url;
            url = this.show.url_mixcloud.replace('https://www.mixcloud.com', '');
            return "https://www.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&hide_artwork=1&feed=" + url;
        }
    }
  },
  apollo: {
    show: {
      // show
      query: gql`
        query show($showId: ID!) {
          show(id: $showId) {
            title
            djs
            dateTimeBroadcast
            date_on_air
            url_mixcloud
            tracks {
              order
              artist
              track
              image
            }
          }
        }
      `,
      // parameters
      variables: function () {
        return {
          showId: this.params.showId,
        };
      },
    },
  },
};
</script>

<style scoped>
.card-title {
  font-size: 1rem;
}
.playme {
  color: #e35313;
  text-decoration:none;
}
</style>
